'use client';

import {useState, useEffect} from 'react';
import Script from 'next/script';
import {_m, NavigationManager} from '@sdk-mobile';
import {getUserId} from '@/services/internal/user/getUserId';
import {Alert} from 'react-native';

type Props = {geoSrc: string};

const setUpGeoLocation = (license: string) => {
  try {
    const geo = GcHtml5.createClient();
    const userId = getUserId();
    geo.setLicense(license);
    geo.setUserId(userId);
    geo.setUserSessionId(userId);
    geo.setReason('Wager');
    window.geoClient = geo;
  } catch (e) {
    Alert.alert(_m('Error'), _m('Cannot get geolocation'), [
      {text: _m('OK'), onPress: () => NavigationManager.popNavigatorToRoot()},
    ]);
  }
};

export default function GeoLocation({geoSrc}: Props) {
  const [library, setLibrary] = useState(false);
  const [license, setLicense] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/geo')
      .then((resp) => resp.text())
      .then(setLicense);
  }, []);

  useEffect(() => {
    if (library && license) {
      setUpGeoLocation(license);
    }
  }, [library, license]);

  return <Script src={geoSrc} strategy='afterInteractive' onReady={() => setLibrary(true)} />;
}
